import CompanyIcon from "../../Icons/CompanyIcon";
import PayrollIcon from "../../Icons/PayrollIcon";
import { RecruitmentIcon } from "../../Icons/RecruitmentIcons";
import ReportIcon from "../../Icons/ReportIcon";
import TimesheetIcon from "../../Icons/TimesheetIcon";
import { TranslatorNavigationTag } from "../../languageTranslator/LanguageTranslatorTags";
export const breads = [
  {
    url: "",
    title: <TranslatorNavigationTag>Shift Assignment</TranslatorNavigationTag>,
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Shift Template",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Activity",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Leave Request",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Leave History",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Leave Calendar",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Leave Category",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Leave Settings",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Individual Leave Settings",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Timesheet",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Timesheet",
    icon: (
      <TimesheetIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "time",
  },
  {
    url: "",
    title: "Payroll Basic Settings",
    icon: (
      <PayrollIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "payroll",
  },
  {
    url: "",
    title: "Pay Breakdown",
    icon: (
      <PayrollIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "payroll",
  },
  {
    url: "",
    title: "Employee Pay Breakdown",
    icon: (
      <PayrollIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "payroll",
  },
  {
    url: "",
    title: "Pay Components",
    icon: (
      <PayrollIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "payroll",
  },
  {
    url: "",
    title: "Pay Structure",
    icon: (
      <PayrollIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "payroll",
  },
  {
    url: "",
    title: "Air Ticket",
    icon: (
      <PayrollIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "payroll",
  },
  {
    url: "",
    title: "Process Payroll",
    icon: (
      <PayrollIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "payroll",
  },
  {
    url: "",
    title: "Teams",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Employees",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Service Request",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "User Role",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Organization Basic Settings",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Office Locations/ Geofencing",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Office Locations/ Geofencing",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Manage Branches",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Bulk Import",
    icon: (
      <CompanyIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "company",
  },
  {
    url: "",
    title: "Talent Poll",
    icon: (
      <RecruitmentIcon
        height={14}
        color="grey"
        className="sidebar-icon-color"
      />
    ),
    type: "recruitment",
  },
  {
    url: "",
    title: "Job Posts",
    icon: (
      <RecruitmentIcon
        height={14}
        color="grey"
        className="sidebar-icon-color"
      />
    ),
    type: "recruitment",
  },
  {
    url: "",
    title: "Recruitment Companies",
    icon: (
      <RecruitmentIcon
        height={14}
        color="grey"
        className="sidebar-icon-color"
      />
    ),
    type: "recruitment",
  },
  {
    url: "",
    title: "Recruitment Companies",
    icon: (
      <RecruitmentIcon
        height={14}
        color="grey"
        className="sidebar-icon-color"
      />
    ),
    type: "recruitment",
  },
  {
    url: "",
    title: "Clock-in Report b",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "User Activity Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Attendance Summary Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Attendance Detailed Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Day wise Attendance Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Employee Master Data",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Asset Assignment",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Employee Nationality Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Employee Gender Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Employee Age Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Document Report",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Leave Balance",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Expense",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Payroll Sheet",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "report",
  },
  {
    url: "",
    title: "Training",
    icon: (
      <ReportIcon height={14} color="grey" className="sidebar-icon-color" />
    ),
    type: "training",
  },
];
